<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch' //check
          ]"
          @btnSearch="btnSearch()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">
                <v-col cols="12" md="2">
                  <v-select
                    label="Division"
                    v-model="divCd"
                    :items="listDivCd"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$list'"
                    dense
                    outlined
                    clearable
                  ></v-select>
                </v-col>
                <i-label :label="'Ship No : '" class="pl-2"/>  
                <v-col cols="12" md="2">
                  <v-select
                    label="Ship No"
                    v-model="shipNo"
                    :items="listShip"
                    return-object 
                    item-value="shipNo" 
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                    clearable                    
                    @change = "btnSearch()"
                  ></v-select>
                </v-col>
                <template v-if="divCd !== '1'">
                  <i-label :label="'Checking Date : '" class="pl-2"/>
                  
                  <v-col cols="12" md="2">
                    <DxDateBox                        
                          :value="frmDate"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {frmDate = e.value && getStrFormat(e.value)}"
                      />                 
                  </v-col>

                  <div class="mx-2">  ~  </div>

                  <v-col cols="12" md="2">
                    <DxDateBox                        
                          :value="toDate"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {toDate = e.value && getStrFormat(e.value)}"
                      />                 
                  </v-col> 
                </template>
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pa-2">
        <i-card-vertical
          style="color: black"
          headerTitle="ZONE FINAL Ship"
          :useBtnList="[
            'btnAdd', //New
            'btnSave', //Save
            'btnDelete' //Delete
          ]"
          @btnAdd="btnAdd()"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="bas0010MainGrid"
                  class="listBox"
                  :ref="dxDataGridRef"
                  :data-source="bas0010MainGrid"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :show-borders="true"
                  :width="grid.width"
                  :show-row-lines="true"
                  key-expr="id"
                  :focused-row-enabled="true"
                  :disablePagination="false"
                  :column-hiding-enabled="false"
                  :column-auto-width="true"
                  :on-row-inserted="e => e.component.navigateToRow(e.key)"
                  :word-wrap-enabled="true"
                  @cellPrepared="cellPrepared"
                  @editing-start="bas0010EditingStart"
                >
                  <!-- @editing-start="bas0010EditingStart" -->
                  <!-- @cellPrepared="cellPrepared" -->
                  <DxPaging :enabled="false" />
                   <DxEditing :allow-updating="true" :allow-adding="true" mode="cell" />
                   <DxSelection select-all-mode="allMode" :show-check-boxes-mode="checkBoxesMode" mode="multiple"                    
                   />
                  <DxColumn
                    data-field="shipNo"
                    :caption="$t('Ship No')"
                    width="80"
                    data-type="string"
                    alignment="center"
                    css-class="devest-grid-header-require"
                    :allow-editing="false"
                  >
                  </DxColumn>

                  <DxColumn
                      data-field="chkDte"
                      caption="Check Date"
                      width="100"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :set-cell-value="chkDateSelect"
                  ></DxColumn>
                  
                  <DxColumn data-field="areaCd" :caption="$t('Area')" width="150" data-type="String" alignment="center" >
                     <DxLookup :data-source="listArea" display-expr="name" value-expr="code" />
                  </DxColumn>                   
                  <DxColumn
                    data-field="deptCd"
                    :caption="$t('Department')"
                    width="200"
                    data-type="string"
                    alignment="center"
                    css-class="devest-grid-header-require"
                    :allow-editing="true"
                    :set-cell-value="onDepartmentChanged"
                  >
                    <DxLookup :data-source="deptList" display-expr="name" value-expr="code" />
                  </DxColumn>
                  <DxColumn
                    data-field="respCd"
                    :caption="$t('Work Group')"
                    width="200"
                    data-type="string"
                    alignment="center"
                    css-class="devest-grid-header-require"
                    :allow-editing="true"
                  >
                    <DxLookup :data-source="getFilteredWorkGroups" display-expr="name" value-expr="code" />
                  </DxColumn>
                  <DxColumn 
                    data-field="qmPart" 
                    :caption="$t('QM Part')" 
                    width="150" 
                    data-type="string" 
                    alignment="center" 
                    css-class="devest-grid-header-require"
                    :allow-editing="true"
                    :set-cell-value="onCheckPointChanged"
                  >
                    <DxLookup :data-source="listQmPart" display-expr="name" value-expr="code" />
                  </DxColumn>
                  <DxColumn 
                    data-field="chkPntCd" 
                    :caption="$t('Cherck Point')" 
                    width="150" 
                    data-type="string" 
                    alignment="center" 
                    css-class="devest-grid-header-require"
                    :allow-editing="true"
                  >
                    <DxLookup :data-source="getFilteredCheckPoint" display-expr="name" value-expr="code" />
                  </DxColumn>                  
                  <DxColumn data-field="descZone" :caption="$t('Description')" width="250" data-type="String" alignment="left" />
                  <DxColumn data-field="rmk" :caption="$t('Countermeasure')" width="120" data-type="String" alignment="left" />
                  <DxColumn
                      data-field="finDte"
                      caption="Completed Date"
                      width="100"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :set-cell-value="finDateSelect"
                  ></DxColumn>
                  <DxColumn caption="Before file" alignment="center">
                    <!-- <DxColumn data-field="fileNmBf" caption="Before photo" width="200" data-type="string" alignment="left" :allow-editing="false"/> -->
                    
                    <DxColumn data-field="bfileYn" name="bfileYn_view" width="100" data-type="string" header-cell-template="Before" cell-template="bfileYn" alignment="center" :allow-editing="false"/>  
                    
                    <DxColumn data-field="bfileYn" name="bfileYn_delete" width="100" data-type="string" header-cell-template="Bdelete" cell-template="bdelete" alignment="center" :allow-editing="false"/>
                  </DxColumn>
                  
                  <template #Before >
                    <div>Attach</div>
                  </template>
                  
                  <template #bfileYn="{ data }">
                    <div>
                      <div v-if="data.data.__created__"></div>

                      <div v-else-if="data.value === 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="triggerUpload(data, 'BF')" >
                          Open
                          <v-icon color="blue">$folder</v-icon>
                        </v-btn>
                      </div>

                      <div v-else-if="data.value !== 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(data, 'BF')" >
                          Preview
                          <v-icon color="blue">$search</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>

                  <template #Bdelete >
                    <div>Delete</div>
                  </template>
                  
                  <template #bdelete="{ data }">
                    <div>
                      <div v-if="!data.data.__created__ && data.value !== 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="deleteFile(data, 'BF')" >
                          Delete
                          <v-icon color="blue">$delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>
                  <DxColumn caption="After file" alignment="center">
                    <!-- <DxColumn data-field="fileNmAf" caption="After photo" width="200" data-type="string" alignment="left" :allow-editing="false"/> -->
                    
                    <DxColumn data-field="afileYn" name="afileYn_view" width="100" data-type="string" header-cell-template="After" cell-template="afileYn" alignment="center" :allow-editing="false"/>                  
                    
                    <DxColumn data-field="afileYn" name="afileYn_delete" width="100" data-type="string" header-cell-template="Adelete" cell-template="adelete" alignment="center" :allow-editing="false"/>
                  </DxColumn>                  
                  <template #After >
                    <div>Attach</div>
                  </template>                  
                  <template #afileYn="{ data }">
                    <div>
                      <div v-if="data.data.__created__"></div>
                      <div v-else-if="data.value === 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="triggerUpload(data, 'AF')" >
                          Open
                          <v-icon color="blue">$folder</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="data.value !== 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(data, 'AF')" >
                          Preview
                          <v-icon color="blue">$search</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>
                  <template #Adelete >
                    <div>Delete</div>
                  </template>                  
                  <template #adelete="{ data }">
                    <div>
                      <div v-if="!data.data.__created__ && data.value !== 'N'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="deleteFile(data, 'AF')" >
                          Delete
                          <v-icon color="blue">$delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>
                  <input type="file" ref="fileInputHidden" style="display: none" accept="image/*" @change="onFileSelected" />
                  <DxColumn data-field="zoneSta" :caption="$t('Repair Status')" width="150" data-type="string" alignment="center" >
                    <DxLookup :data-source="listZoneSta" display-expr="name" value-expr="code" />
                  </DxColumn>
                  
                </DxDataGrid>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <div v-if="isPreviewPopupOpen" class="preview-overlay" @click="closePreviewPopup">
      <div class="preview-content" @click.stop>
        <button type="button" class="preview-close-btn" @click="closePreviewPopup">×</button>
        
        <div class="preview-body">
          <embed 
            v-if="previewFileType === 'pdf'" 
            :src="previewFileData" 
            type="application/pdf" 
            class="preview-iframe" 
          />
          
          <img 
            v-else 
            :src="previewFileData" 
            class="preview-img" 
            alt="Preview Content" 
          />
        </div>
        
        <div class="preview-footer">{{ previewFileName }}</div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import iButton from '@/components/common/iButton'
import DxDateBox from 'devextreme-vue/date-box'
import themes from 'devextreme/ui/themes'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import { 
         getCheckPoint, 
         getArea, 
         getDivision, 
         searchZoneList, 
         saveZone, 
         deleteZone,
         uploadZoneFileFtp,  // <-- Thêm hàm upload file FTP mới
         deleteZoneFile      // <-- Thêm hàm xóa file FTP mới
        } from '@/api/view/tqm/80/v80d3010.js'
import  { getShipList, 
          getDeptList,
          getRespList,
          getQMPartList,
        } from '@/api/view/tqm/80/v80comm.js'         
import { getCmCode, getCmChildCode} from '@/api/system/cmCodeManage'
import moment from 'moment'
import {getDateFormat, getCurrentDate } from '@/utils/common.js'
import {ftpDownloadViewer} from "@/api/view/tqm/common/common.js";

export default {
  name: 'v80d3010pc',
  mixins: [baseview, BaseDataGrid],

  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager,
    iButton
  },
  data() {
    return {
      dxDataGridRef: 'dxDataGridRef',
      bas0010MainGrid: [],
      // ĐĂNG KÝ THÊM 2 TRƯỜNG NÀY ĐỂ QUẢN LÝ THAO TÁC UPLOAD FILE
      currentUploadRowData: null, 
      currentUploadDiv: '', // 'BF' hoặc 'AF'

      listClickData: null,

      listQmPart: [
        {code: 'M', name: 'Outfitting'},
        {code: 'P', name: 'Painting'},
      ],
      listZoneSta: [
        {code: 'C', name: 'Completed'},
        {code: 'N', name: 'Not yet'},
      ],
      checkBoxesMode: 'onClick', // themes.current().startsWith('material') ? 'always' : 'onClick',

      listShip: [],
      shipNo: '',
      
      toDay: '',
      frmDate: '',
      toDate: '',
      divCd: '1',
      listDivCd: [],
      deptList: [],
      deptCd: '',
      respList: [],
      respCd: '',
      listChkPoint: [],
      listArea: [],

      // Thêm các biến quản lý Popup Preview dưới đây:
      isPreviewPopupOpen: false,
      previewFileData: '',
      previewFileType: '',
      previewFileName: '',

      writeYn: this.$gUtil.getWriteYn(),
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.dxDataGridRef)
    },


  },
  methods: {
    getStrFormat(date) {
      return getDateFormat(date)
    },
    async setCombo() {

      let params = { shipNo: '' }     

      //getCheckPoint
      const ckeckPoint = async () => {
        await getCheckPoint(params).then(result => {
          result.list.forEach(item => {
            this.listChkPoint.push({
              name: item.name,
              code: item.code,
              qmPart: item.qmPart || ''
            })
          })
        })
      }
      // getShipList
      const ship = async () => {
        await getShipList(params).then(result => {
           this.listShip.push('All')
                  result.list.forEach(e => {
                    this.listShip.push(e.shipNo)
                  });
                  this.shipNo = this.listShip[0]
        })
      }

      // getDivision
      const division = async () => {
        await getDivision(params).then(result => {
          this.listDivCd = result.list
        })
        // this.divCd = this.listDivCd[0];
      }

      // getDeptList
      const dept = async () => {
        await getDeptList(params).then(result => {
          result.list.forEach(item => {
            this.deptList.push({
              name: item.deptCd + ': '+ item.deptNm,
              code: item.deptCd
            })
          })
        })
      }

      let params1 = { deptCd: '' }
      // getRespList
      const resp = async () => {
        await getRespList(params1).then(result => {
          result.list.forEach(item => {
            this.respList.push({
              name: item.respCd + ': '+ item.respNm,
              code: item.respCd,
              deptCd: item.deptCd || ''
            })
          })
        })
      }
      // getArea
      const area = async () => {
        await getArea(params).then(result => {
            result.list.forEach(item => {
            this.listArea.push({
              name: item.name,
              code: item.code
            })
          })
        })
      }

      //     
      await Promise.all([ship(), division(), dept(), resp(), area(), ckeckPoint()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })
    },
    
    //PK part modification[edit] function control
    bas0010EditingStart(e) {
       this.gridMainInstance.selectRows(e.data.id, true)
      if (e.data.__created__ === false) {
        if ( e.column.dataField === 'shipno' ) {
          e.cancel = true
        }
      } 
    },
    cellPrepared(e) {
      if (e.rowType === 'data') {
        if (e.rowType === 'data' && e.rowIndex >= 0) {
          // console.log('e.data.__created__', e.data.__created__)
          if (!e.data.__created__) {
            if ( e.column.dataField === 'shipno' )  {
              e.cellElement.classList.add('cancel-editable-cell')
            }
          }
        }
      }
    },
    finDateSelect(newData , value , currentRowData){
      // this.dataList[currentRowData.id - 1].fday = getDateFormat(value)
      newData.finDte = getDateFormat(value)
    },
    chkDateSelect(newData , value , currentRowData){
      newData.chkDte = getDateFormat(value)
    },
    /**
    * Hàm lọc danh sách Work Group tương ứng với dòng Department đang chọn
    */
    getFilteredWorkGroups(options) {
      return {
          store: this.respList,
          // Lấy giá trị deptCd của dòng hiện tại để thực hiện filter dữ liệu trên Grid
          filter: options.data ? ['deptCd', '=', options.data.deptCd] : null
      };
    },
    getFilteredCheckPoint(options) {
      return {
          store: this.listChkPoint,
          // Lấy giá trị qmPart của dòng hiện tại để thực hiện filter dữ liệu trên Grid
          filter: options.data ? ['qmPart', '=', options.data.qmPart] : null
      };
    },
    /**
    * Sự kiện kích hoạt khi người dùng thay đổi phòng ban trên Grid.
    * Giúp tự động xóa sạch Work Group cũ tránh râu ông nọ cắm cằm bà kia.
    */
    onDepartmentChanged(newData, value, currentRowData) {
      // Gán giá trị Department mới cho dòng
      newData.deptCd = value;  
      // Reset giá trị Work Group (respCd) về null trên giao diện dòng đó
      newData.respCd = null;
    },
    onCheckPointChanged(newData, value, currentRowData) {
      // Gán giá trị QM Part mới cho dòng
      newData.qmPart = value;
      // Reset giá trị Check Point (chkPntCd) về null trên giao diện dòng đó
      newData.chkPntCd = null;
    },
    /**
     * BƯỚC 1: Khi nhấn Open, lưu thông tin dòng và kích hoạt hộp thoại chọn file của Windows
     */
    triggerUpload(cellData, divType) {
      this.currentUploadRowData = cellData.data; // Lưu nguyên object hàng đang click
      this.currentUploadDiv = divType;           // Nhận diện 'BF' hoặc 'AF'      
      
      // Kích hoạt click vào thẻ input file ẩn dán ở cuối template
      this.$refs.fileInputHidden.click();
    },
    /**
     * BƯỚC 2: Xử lý ngay sau khi người dùng chọn xong file ảnh từ máy tính
     */
    async onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Chuẩn bị FormData đóng gói để gửi lên API Backend
      const formData = new FormData();
      formData.append("file", file);
      formData.append("shipNo", this.currentUploadRowData.shipNo);
      formData.append("zoneSeq", this.currentUploadRowData.zoneSeq); // Đảm bảo dòng đã có khóa chính DB
      formData.append("fileType", this.currentUploadDiv); // Truyền 'BF' hoặc 'AF'

      try {
        this.openLoading('Uploading file to FTP...');
        
        // Gọi API upload file FTP lên Backend Java
        const response = await uploadZoneFileFtp(formData);
        // console.log('response', response);
        
        // === ĐOẠN CẬP NHẬT MỚI CHUẨN XÁC ===
        if (response) {
          let isSuccess = false;
          let serverMessage = '';

          // 1. Phân tích dữ liệu phản hồi (Ép kiểu từ chuỗi JSON nếu có)
          let resData = response.data;
          if (typeof resData === 'string') {
            try {
              // Nếu Backend trả về chuỗi dạng JSON object, tiến hành chuyển đổi sang Object JS
              resData = JSON.parse(resData);
            } catch (e) {
              // Nếu là chuỗi text đường dẫn thô thông thường, giữ nguyên
            }
          }

          // 2. KIỂM TRA ĐIỀU KIỆN THÀNH CÔNG ĐA TẦNG
          if (
            response.status === 200 || 
            response.status === 'SUCCESS' ||
            resData?.status === 'SUCCESS' ||
            (typeof response.data === 'string' && response.data.includes('/attachfile/')) ||
            (resData?.data && String(resData.data).includes('/attachfile/'))
          ) {
            isSuccess = true;
          } else {
            serverMessage = resData?.message || resData?.msg || '';
          }

          // 3. HIỂN THỊ THÔNG BÁO VÀ RELOAD GRID DỮ LIỆU
          if (isSuccess) {
            // Bắn thông báo thành công xanh mượt chuẩn hệ thống
            this.vToastify(this.$t('Upload file successfully...'), 'success');

            // Reload lại Grid để cập nhật dữ liệu hiển thị file mới nhất
            if (typeof this.doSearchMainList === 'function') {
              this.doSearchMainList();
            } else if (typeof this.searchList === 'function') {
              this.searchList();
            }
          } else {
            // Hiển thị thông báo lỗi chi tiết từ server nếu có
            this.vToastify(serverMessage || 'Upload failed from server', 'warn');
          }
        }

      } catch (error) {
        console.error("Upload error log:", error);
        this.vToastify(response.data?.message || 'Upload failed', 'warn');
      } finally {
        event.target.value = ''; // Reset input để lần sau chọn lại file cũ không bị kẹt sự kiện
        this.endLoading();
      }
    },
    /**
     * BƯỚC 3: Sửa lại hàm xem ảnh (Preview)
     */
    async openFile(e, divType) {
      // Vì DxDataGrid cell-template truyền qua biến "data", chúng ta bóc tách dữ liệu gốc ra:
      const rowData = e.data;
      let fileName = divType === 'BF' ? rowData.fileNmBf : rowData.fileNmAf;
      let filePath = '';
      if (!fileName) {
        this.vToastify('No file name found to preview!', 'warn');
        return;
      }

      try {
        this.openLoading('Loading file preview...');
        
        filePath = 'attachfile/TQM/ZONE_FINAL/' + rowData.shipNo + '/' + fileName;
        
        // Gọi API chung có sẵn của hệ thống
        const response = await ftpDownloadViewer(filePath, 'temp_file'); 
        const fileRes = response.data || response; 

        if (fileRes && fileRes.body) {
          const ext = fileName.split('.').pop().toLowerCase();
          let dataType = `data:image/${ext};base64,`;
          
          if (ext === 'pdf') {
            dataType = "data:application/pdf;base64,";
          }

          // 1. Gán dữ liệu Base64 đầy đủ vào biến state
          this.previewFileData = dataType + fileRes.body;
          this.previewFileType = ext;
          this.previewFileName = fileName;

          // 2. Bật Popup lơ lửng xuất hiện bừng sáng màn hình
          this.isPreviewPopupOpen = true;

        } else {
          this.vToastify('Could not load file content from server.', 'warn');
        }

      } catch (error) {
        console.error("Preview Error:", error);
        this.vToastify(error.message || 'Preview failed', 'warn');
      } finally {
        this.endLoading();
      }
    }, 
    // Hàm đóng popup khi nhấn dấu X hoặc click ra ngoài màn hình nền tối
    closePreviewPopup() {
      this.isPreviewPopupOpen = false;
      this.previewFileData = '';
      this.previewFileType = '';
      this.previewFileName = '';
    },

    /**
     * BƯỚC 4: Sửa lại hàm xóa file vật lý đính kèm
     */
    /**
     * Sửa lại hàm xóa file vật lý đính kèm theo Cách A (Phòng vệ đa tầng kết quả trả về)
     */
    async deleteFile(e, divType) {
      const rowData = e.data;
      let fileName = divType === 'BF' ? rowData.fileNmBf : rowData.fileNmAf;
      const targetPhotoType = divType === 'BF' ? 'Before' : 'After';

      if (!fileName) return;

      // Bước 1: Hiển thị hộp thoại hỏi Xác nhận (Prompt) trước khi xóa
      this.vToastifyPrompt(
        `Do you want to delete this ${targetPhotoType} photo file on FTP Server?`,
        'info',
        async current => {
          this.openLoading('Deleting file on FTP...');
          try {
            const params = {
              shipNo: rowData.shipNo,
              zoneSeq: rowData.zoneSeq,
              fileType: divType,
              fileName: fileName
            };
            
            // Gọi API Axios thực hiện xóa file trên FTP
            const response = await deleteZoneFile(params);
            // console.log('deleteZoneFile response:', response);
            
            // Ép kiểu phân tích dữ liệu phòng vệ tương tự như hàm Upload đã chạy thành công
            let resData = response?.data;
            if (typeof resData === 'string') {
              try {
                resData = JSON.parse(resData);
              } catch (jsonErr) {
                // Giữ nguyên chuỗi thô nếu không phải JSON
              }
            }

            // Bước 2: KIỂM TRA ĐIỀU KIỆN THÀNH CÔNG ĐA TẦNG ĐỒNG BỘ VỚI HÀM UPLOAD
            if (
              response?.status === 200 || 
              response?.status === 'SUCCESS' ||
              resData?.status === 'SUCCESS' ||
              String(resData).includes('SUCCESS')
            ) {
              
              // Bước 3: Bắn thông báo Toastify dạng 'success' màu xanh mượt mà lên góc màn hình
              this.vToastify(this.$t('Deleted photo successfully!'), 'success');                        
              
              // Bước 4: Làm tươi lưới dữ liệu Grid từ DB để cập nhật trạng thái cờ file về 'N' (Hiện lại nút Open)
              if (typeof this.doSearchMainList === 'function') {
                this.doSearchMainList();
              } else if (typeof this.searchList === 'function') {
                this.searchList();
              }

            } else {
              // Trường hợp API chạy qua nhưng Backend trả về nội dung lỗi cụ thể
              this.vToastify(resData?.message || 'Delete file failed from server', 'warn');
            }

          } catch (error) {
            console.error("Delete FTP File Error:", error);
            this.vToastify(error.message || 'Delete failed', 'warn');
          } finally {
            this.endLoading();
          }
        },
        null,
        true
      );
    },
    
    btnSearch() {
      this.doSearchMainList()
    },
    doSearchMainList(event) {
      console.log('event', event);
      
      // Khởi tạo lại trạng thái Grid và dòng dữ liệu đang chọn
      this.bas0010MainGrid = [];
      this.listClickData = null;

      // Kiểm tra điều kiện bắt buộc: Phải chọn Số tàu trước khi tìm kiếm
      if (!this.shipNo) {
        this.vToastify(this.$t('Please, select Ship No.'), 'warn');
        return;
      }

      this.openLoading('searching');
      let params = {};

      if (event) {
        // Trường hợp clear hoặc có event đặc biệt từ hệ thống (giữ nguyên logic gốc của bạn)
        params = {
          divCd: '',
          shipNo: '',
          frmDate: '',
          toDate: ''
        };
      } else {
        // Trường hợp tìm kiếm thông thường (Xử lý đồng bộ dựa trên SQL Backend)
        
        // 1. Kiểm tra xem người dùng có chọn Division là "All" (mã là '1') hay không
        const isDivisionAll = this.divCd === '1';

        // 2. Xử lý giá trị shipNo (nếu chọn Object hoặc chuỗi "All")
        let targetShipNo = '';
        if (this.shipNo === 'All') {
          targetShipNo = '%'; // Đưa về kí tự đại diện để SQL chạy lệnh LIKE '%%'
        } else {
          targetShipNo = typeof this.shipNo === 'object' ? this.shipNo.shipNo : this.shipNo;
        }

        // 3. Khởi tạo đối tượng parameters gửi lên API
        params = {
          divCd: this.divCd,
          shipNo: targetShipNo,
          // Nếu Division là All ('1') -> Ẩn ô ngày -> Truyền rỗng để tối ưu SQL
          // Nếu Division là chế độ khác ('2') -> Hiển thị ô ngày -> Truyền giá trị đã chọn
          frmDate: isDivisionAll ? '' : this.frmDate,
          toDate: isDivisionAll ? '' : this.toDate
        };
      }

      // console.log("===> Parameters gửi xuống Backend thực tế: ", params);

      // Gọi API lấy danh sách dữ liệu từ Backend
      searchZoneList(params)
        .then(res => {       
          this.bas0010MainGrid = res.list || [];     
          // console.log("===> Biến component (this.bas0010MainGrid): ", this.bas0010MainGrid);        
          // console.log("Danh sách dạng thô: ", JSON.parse(JSON.stringify(res.list)));     
        })
        .catch(err => {
          console.error("Lỗi khi gọi API searchZoneList: ", err);
          this.vToastify(this.$t('An error occurred while fetching data.'), 'error');
        })
        .finally(() => {                      
          this.endLoading();          
        });
    },
        
    btnAdd() {
        
        if (!this.writeYn) {
          this.vToastify(this.$t('You no have authority to Add.'), 'warn')
          return
        }

        if (!this.shipNo || this.shipNo == "All") {
          this.vToastify(this.$t('Please, select Ship No.'), 'warn')
          return
        }

      let check = this.bas0010MainGrid.findIndex(e => e.__created__ === true)
                let newRow = {
                  id: this.bas0010MainGrid.length + 1 + '',
                  shipNo: this.shipNo,
                  chkDte: this.toDay,
                  bfileYn: 'N',
                  afileYn: 'N',
                  userId: this.$store.state.user.userId,
                  __modified__: false,
                  __created__: true
                }
                this.gridMainInstance.newRow(newRow)
                // console.log('newRow: ', newRow)
                this.gridMainInstance.selectRows(newRow.id, true)
                this.gridMainInstance.option('focusedRowIndex', -1)
    },
    async btnSave() {
        if (!this.writeYn) {
          this.vToastify(this.$t('You no have authority to Save.'), 'warn')
          return
        }

        await this.gridMainInstance.saveEditData()

        // Lấy các dòng được tích chọn checkbox trên DxDataGrid để tiến hành lưu dữ liệu
        const selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }

        // Kiểm tra tính hợp lệ dữ liệu (Validity check)
        for (let row of selectedMainRows) { 
          if (!row.shipNo) {
            this.vToastify(this.$t('requiredCheck') + '[Ship No]', 'warn')
            return
          }

          // Xử lý dữ liệu text trống để tránh lỗi null value
          Object.keys(row).forEach(key => {
              if(key !== '__created__' && key !== '__modified__') {
                row[key] = row[key] ? row[key] : ''
              }
          })

          // Gán ID người dùng đang đăng nhập từ Vuex Store
          row.userId = this.$store.state.user.userId
        }

        try {
          this.openLoading('saving') // Thay đổi text hiển thị trạng thái đang lưu
          // console.log('selectedMainRows', selectedMainRows);
          // SỬA TẠI ĐÂY: Gọi API saveZone gộp thay cho hàm cũ
          await saveZone(selectedMainRows).then(res => {
            this.vToastify(this.$t('Saved successfully...'), 'success')
          })
          .catch(error => {
            this.vToastify(error, 'warn')
          })
          .finally(() => {
            this.gridMainInstance.endUpdate()
            this.doSearchMainList() // Tải lại danh sách lưới sau khi lưu xong
          })
        } finally {
          this.endLoading()
        }
    },  
    /**
     * HÀM btnDelete: Xóa hạng mục dữ liệu (Đã đơn giản hóa theo tư duy hàm Save)
     */
    async btnDelete() {
      // 1. Kiểm tra quyền hạn ghi/xóa của User
      if (!this.writeYn) {
        this.vToastify(this.$t('You do not have authority to Delete.'), 'warn');
        return;
      }

      // 2. Lấy danh sách các dòng được tích chọn Checkbox
      const selectedRows = (await this.gridMainInstance.getSelectedRowsData()) || [];
      if (!selectedRows.length) {
        this.vToastify(this.$t('SelectCheck'), 'warn');
        return;
      }

      // 3. Hiển thị thông báo xác nhận xóa
      this.vToastifyPrompt(
        this.$t('Do you want to delete the selected item(s)?'),
        'info',
        async current => {
          this.openLoading('Processing delete...');
          try {
            const realRowsToDelete = [];

            // BƯỚC 1: Duyệt qua từng dòng để xử lý xóa file vật lý trên FTP trước
            for (const row of selectedRows) {
              if (!row) continue;

              if (row.__created__) {
                // Nếu là dòng ảo vừa ấn Add chưa lưu -> Xóa trực tiếp trên giao diện Grid
                this.gridMainInstance.deleteRow(this.gridMainInstance.getRowIndexByKey(row.id));
              } else {
                // Thêm vào danh sách dòng thực tế để xóa dưới DB sau
                realRowsToDelete.push(row);

                // Nếu có file Before -> Gọi API xóa file vật lý trên FTP trước
                if (row.fileNmBf && row.bfileYn !== 'N') {
                  try {
                    await deleteZoneFile({
                      shipNo: row.shipNo,
                      zoneSeq: row.zoneSeq,
                      fileType: 'BF',
                      fileName: row.fileNmBf
                    });
                  } catch (ftpErr) {
                    console.warn("Ignore FTP Before Delete Error:", ftpErr);
                  }
                }

                // Nếu có file After -> Gọi API xóa file vật lý trên FTP trước
                if (row.fileNmAf && row.afileYn !== 'N') {
                  try {
                    await deleteZoneFile({
                      shipNo: row.shipNo,
                      zoneSeq: row.zoneSeq,
                      fileType: 'AF',
                      fileName: row.fileNmAf
                    });
                  } catch (ftpErr) {
                    console.warn("Ignore FTP After Delete Error:", ftpErr);
                  }
                }
              }
            }

            // BƯỚC 2: Sau khi dọn dẹp FTP xong, tiến hành xóa Record dưới Database một cục
            if (realRowsToDelete.length > 0) {
              
              // Gọi API Java xóa dữ liệu dưới DB (Truyền mảng thô trực tiếp giống hàm Save)
              const res = await deleteZone(realRowsToDelete);
              console.log('API deleteZone Response:', res);

              // Hiển thị thông báo thành công xanh mượt mà
              this.vToastify(this.$t('Delete successful...'), 'success');
              this.gridMainInstance.clearSelection();
              
              // Làm tươi lưới dữ liệu
              if (typeof this.doSearchMainList === 'function') {
                this.doSearchMainList();
              } else if (typeof this.searchList === 'function') {
                this.searchList();
              }

            } else {
              // Trường hợp chỉ tích chọn xóa các hàng ảo vừa Add chưa lưu DB
              this.vToastify(this.$t('Delete successful...'), 'success');
              this.gridMainInstance.clearSelection();
            }

          } catch (error) {
            console.error("Critical Delete Error:", error);
            this.vToastify(error.message || 'Delete rows failed', 'warn');
          } finally {
            this.endLoading();
          }
        },
        null,
        true
      );
    },   

  },
  mounted() {
    // console.log("writeYn: ", this.writeYn );
   let toDay = new Date      
      this.frmDate = toDay.setDate(toDay.getDate() - 30);
      toDay = new Date
      this.toDate = toDay.setDate(toDay.getDate() + 0);

      this.toDay = toDay.setDate(toDay.getDate() + 0);

      this.frmDate = dayjs(this.frmDate).format('YYYY-MM-DD')
      this.toDate = dayjs(this.toDate).format('YYYY-MM-DD')
      this.toDay  = dayjs(this.toDay).format('YYYY-MM-DD')

    // setTimeout(() => this.gridMainInstance.refresh(), 100)
    // this.doSearchMainList(true)
  },
  created() {
    this.setCombo()
  },
  beforeMount() {
    
  }
}
</script>
<style scoped>
/* Lớp nền tối mờ bao phủ toàn màn hình */
.preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Màu nền đen mờ tỉ lệ 80% */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999; /* Chỉ số z-index siêu cao để đè lên DxDataGrid và Menu hệ thống */
}

/* Khung nội dung trung tâm chứa ảnh / PDF */
.preview-content {
  position: relative;
  background-color: #1e1e1e;
  border-radius: 8px;
  width: 85%;
  max-width: 1000px;
  height: 85%;
  max-height: 750px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  overflow: hidden;
  border: 1px solid #3c3c3c;
}

/* Nút đóng hình dấu X ở góc trên bên phải */
.preview-close-btn {
  position: absolute;
  top: 10px;
  right: 20px;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  z-index: 100000;
  line-height: 1;
  transition: color 0.2s, transform 0.2s;
}
.preview-close-btn:hover {
  color: #ff4d4d; /* Đổi sang màu đỏ rực khi hover chuột vào */
  transform: scale(1.1);
}

/* Vùng không gian chính hiển thị nội dung file */
.preview-body {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  overflow: hidden;
  background-color: #090909; /* Nền tối tuyệt đối tôn dáng hình ảnh */
}

/* Định dạng hình ảnh co giãn theo tỷ lệ chuẩn */
.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

/* Định dạng khung iframe nhúng tài liệu (PDF) */
.preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background-color: #ffffff;
}

/* Thanh hiển thị tên file dưới chân Popup */
.preview-footer {
  padding: 12px;
  background-color: #1a1a1a;
  color: #aaaaaa;
  text-align: center;
  font-size: 13px;
  font-family: Arial, sans-serif;
  border-top: 1px solid #2d2d2d;
}
</style>
